/**
 * @generated SignedSource<<65d1b8e5088fd9a3209d657c2925cd42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnalyticsDatumCardRow_analyticsDatum",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ],
  "type": "AnalyticsDatumInterface",
  "abstractKey": "__isAnalyticsDatumInterface"
};

node.hash = "d284e0fde3aa7880a4c8c4106d99d306";

module.exports = node;
